import ToastComponent from './ToastComponent'

export default ToastComponent
